import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';

import { useShoppingCart } from 'src/components/report/ShoppingCartContext';

import { styles } from './styles.index';

interface ReportTableHeadProps {
  showCustomReports: boolean;
}

export const ReportTableHead: FC<ReportTableHeadProps> = ({
  showCustomReports,
}) => {
  const { t } = useTranslation('report');
  const { canUseShoppingCart } = useShoppingCart();

  return (
    <TableRow>
      <TableCell sx={styles.tableHeadCell}>{t('reportInfo.name')}</TableCell>

      {canUseShoppingCart ? (
        <TableCell sx={styles.tableHeadCell} align="center">
          {t('reportInfo.type')}
        </TableCell>
      ) : (
        <TableCell sx={styles.tableHeadCell} align="center">
          {t('reportInfo.language')}
        </TableCell>
      )}

      {canUseShoppingCart && (
        <TableCell sx={styles.tableHeadCell} align="center">
          {t('reportInfo.fileType')}
        </TableCell>
      )}

      {showCustomReports && (
        <TableCell sx={styles.tableHeadCell} align="center">
          {t('reportInfo.orderStatus')}
        </TableCell>
      )}

      {showCustomReports && (
        <TableCell sx={styles.tableHeadCell} align="center">
          {t('reportInfo.lastModified')}
        </TableCell>
      )}

      {showCustomReports && (
        <TableCell sx={styles.tableHeadCell} align="center">
          {t('reportInfo.createdBy')}
        </TableCell>
      )}

      {showCustomReports && (
        <TableCell sx={styles.tableHeadCell} align="center">
          {t('reportInfo.sharedBy')}
        </TableCell>
      )}

      <TableCell sx={styles.tableHeadCell} align="right">
        {!showCustomReports
          ? t('reportInfo.download')
          : t('reportInfo.actions')}
      </TableCell>
    </TableRow>
  );
};

export default ReportTableHead;
